import { AD_STATUS, AD_STATUS_EXTENSION_CODE, DESIGN_STATUS } from "@/Constants/adStatus";
import { ColorDotBadge } from "./ColorDotBadge";
import { Box, ColorSwatch, Group, Loader, Paper, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import classes from "./StatusBadge.module.css";

const STATUSES_BY_CODE = Object.fromEntries(
    Object.entries(AD_STATUS)
        .filter(([, status]) => status.code !== null)
        .map(([key, status]) => [status.code, { ...status, key }])
);
STATUSES_BY_CODE[AD_STATUS_EXTENSION_CODE] = STATUSES_BY_CODE[AD_STATUS.PUBLISHED.code];

const DESIGN_STATUSES_BY_CODE = Object.fromEntries(
    Object.entries(DESIGN_STATUS).map(([key, status]) => [status.code, { ...status, key }])
);

/**
 * AD-207: pausing or resuming goes out to DV360 and takes around twenty seconds.
 * `pending` swaps the status dot for a spinner for that whole window, so the badge
 * itself says the click was taken rather than leaving the row looking inert.
 */
export const StatusBadge = ({ code, designStatus = null, isArchived = false, text = null, pending = false, ...props }) => {

    const { t } = useTranslation();

    // AD-220: a "Let Us Design It" ad in the design loop shows where the design is.
    const status = isArchived
        ? { ...AD_STATUS.ARCHIVED, key: 'ARCHIVED' }
        : (DESIGN_STATUSES_BY_CODE[designStatus] || STATUSES_BY_CODE[code] || { ...AD_STATUS.DRAFT, key: 'DRAFT' });

    return (
        <Group>
            <Paper className={classes[status.key.toLowerCase()]} bg="var(--status-bg)" px={8} py={2}>
                <Group gap={4} wrap="nowrap">
                    {pending
                        ? <Loader size={10} color="var(--status-dot)" />
                        : <ColorSwatch color="var(--status-dot)" size={5} withShadow={false} />}
                    <Text fz={14} fw={500} c="var(--status-fg)" style={{ whiteSpace: "nowrap" }}>{text ? text : t(`adStatus.${status.label.toLowerCase().replace(/ (\w)/g, (_, c) => c.toUpperCase())}`)}</Text>
                </Group>
            </Paper>
        </Group>
    )

    return (
        <ColorDotBadge color={status.color} bg={status.bg} {...props}>
            {text ? text : t(`adStatus.${status.label.toLowerCase()}`)}
        </ColorDotBadge>
    )
}
